export default __webpack_public_path__ + "static/media/flamingo.3dacb7bf.png";